import React, { FC, useEffect, useRef, useState } from 'react';
import { Button, Keyboard, Modal, StyleSheet, Text, TextInput, View, FlatList, ScrollView, LayoutChangeEvent } from 'react-native';
import { getAvatarByItem2 } from '../../utils/utils';
import { TopicWithSummary } from "../../../imsdk/api/topic";
import { LeftView } from "./CListItem";
import { color_333333, color_666666, color_999999, color_BEBEBE, color_main, ColorGrey } from "../../assets/style/colors";
import { Str_Cancel, Str_LeaveMessageFriends, Str_Send, Str_SendTo } from "../../language/string_res";
import Animated, { useAnimatedStyle, useSharedValue, withSpring } from 'react-native-reanimated';
import { useWindowDimensions } from 'react-native';


interface IProps {
    modalVisible: boolean;
    receivers: TopicWithSummary[];
    message: string;
    cancel: () => void;
    confirm: (msg: string) => void;
}
export const ForwardConfirmModal: FC<IProps> = (props: IProps) => {
    const { height: screenHeight } = useWindowDimensions();
    const { modalVisible, receivers, message, cancel, confirm } = props;

    const [inputVal, setInputVal] = useState('');
    const keyboardHeight = useSharedValue(0)
    const contentHeight = useRef(0)
    const animatedStyle = useAnimatedStyle(() => ({
        transform: [
            { translateY: keyboardHeight.value },
        ],
    }));

    useEffect(() => {
        const keyboardDidShowListener = Keyboard.addListener(
            'keyboardDidShow',
            (event) => {
                const height = event.endCoordinates.height
                const value = height - (screenHeight - contentHeight.current) / 2
                keyboardHeight.value = withSpring(-value)
            }
        );
        const keyboardDidHideListener = Keyboard.addListener(
            'keyboardDidHide',
            () => {
                keyboardHeight.value = withSpring(0)
            }
        );
        return () => {
            keyboardDidShowListener.remove();
            keyboardDidHideListener.remove();
        };
    }, []);

    useEffect(() => {
        if (!modalVisible) {
            setInputVal('');
        }
    }, [modalVisible]);

    const sendMsg = () => {
        confirm(inputVal);
    };

    //单个接收者
    const SingleReceiver = ({ item }: { item: TopicWithSummary }) => {
        return (
            <>
                <LeftView left={getAvatarByItem2(item)} size={40} />
            </>
        );
    };
    const onLayout = (event: LayoutChangeEvent) => {
        contentHeight.current = event.nativeEvent.layout.height
    }
    return (
        <Modal
            transparent={true}
            visible={modalVisible}
            statusBarTranslucent={true}
            style={{ opacity: 0.3 }}>
            <View style={styles.modalWrap}>
                <Animated.View
                    onLayout={onLayout}
                    style={[animatedStyle, styles.modalView]}>
                    <Text style={styles.modalTitle}>{Str_SendTo}</Text>
                    <FlatList
                        horizontal
                        showsHorizontalScrollIndicator={false}
                        style={styles.receiverContainer}
                        data={receivers}
                        renderItem={SingleReceiver}
                    />

                    <ScrollView style={styles.msgContainer}>
                        <Text style={styles.msg}>{message}</Text>
                    </ScrollView>

                    <View style={styles.inputContainer}>
                        <TextInput
                            placeholder={Str_LeaveMessageFriends}
                            placeholderTextColor={color_BEBEBE}
                            style={styles.input}
                            value={inputVal}
                            maxLength={200}
                            onChangeText={(val) => setInputVal(val)}
                            onSubmitEditing={() => Keyboard.dismiss()}
                        />
                    </View>
                    <View
                        style={styles.btnContainer}>
                        <Button
                            onPress={() => cancel()}
                            title={Str_Cancel}
                            color={color_999999}
                        />
                        <Button
                            onPress={() => sendMsg()}
                            title={Str_Send}
                            color={color_main}
                        />
                    </View>
                </Animated.View>
            </View>
        </Modal >
    );
};

const styles = StyleSheet.create({
    modalWrap: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,0.5)',
    },
    modalView: {
        backgroundColor: 'white',
        borderRadius: 4,
        padding: 20,
        width: '85%',
        minHeight: 250,
        maxHeight: '60%',
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        elevation: 5,
    },
    modalTitle: {
        fontSize: 16,
        color: color_333333,
        fontFamily: '',
        fontWeight: '600',
    },
    receiverContainer: {
        marginTop: 20,
        borderBottomWidth: 1,
        borderBottomColor: ColorGrey,
        minHeight: 55,
        paddingBottom: 10,
    },
    msgContainer: {
        marginTop: 15,
        marginBottom: 20,
    },
    msg: {
        fontSize: 14,
        color: color_666666,
    },
    inputContainer: {
        borderBottomWidth: 1,
        borderBottomColor: ColorGrey,
        paddingBottom: 15,
    },
    input: {
        height: 40,
        borderColor: ColorGrey,
        borderWidth: 1,
        color: color_333333,
        backgroundColor: ColorGrey,
        borderRadius: 4,
        paddingLeft: 15,
    },
    btnContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingLeft: '20%',
        paddingRight: '20%',
        marginTop: 10,
    },
});
